import createModelStore from "../../../utils/createModelStore";
import Map from "../../services/Map";

export default createModelStore<Map.LocalObject, "localObjects">(
	"localObjects",
);
